module.exports = __webpack_public_path__ + "static/media/mili_logo_new_x5.06fca56d.png";